module.exports = __webpack_public_path__ + "static/media/monetizationOn.03c35179.png";